import { Dispatch, useState } from 'react';
import arrowLeft from '../../assets/icons/arrowLeft.svg'
import { useRenewal } from '../../context/RenewalContext';
import { postRequest } from '../../services/api';
import useFormatDocuments from '../../hooks/useFormatDocuments';
import { ErrorProps, OfferItem } from '../../types/types';
import { getErrorCodes, getErrorMessage, getErrorSugestions, getErrorSubTitle } from '../../utils/errorMessages';
import {
  Container,
  ContentWrapper,
  TextTop,
  TextTitle,
  TextSubtitle,
  Form,
  ButtonWrapper,
  ButtonBack,
  ButtonPurchase,
  Image,
  Paragraph,
  TextSugestions,
  ListErrors
} from './style';

interface ModalProps {
  setPortability: Dispatch<boolean>
  setLoading: Dispatch<boolean>
  offer: OfferItem | undefined;
}

const Modal = ({ setPortability, setLoading, offer }: ModalProps) => {
  const { setData } = useRenewal();
  const [error, setError] = useState<ErrorProps | null>(null)
  const [cnpj, setCnpj] = useState<string>('');
  const { formattedCnpj } = useFormatDocuments(undefined, cnpj);

  const handleCloseModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setPortability(false);
    setError(null);
  }

  const handleGoToVitrine = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (error?.code === '8001') {
      setError(null);
    } else {
      setPortability(false);
      setError(null);
      window.location.href = 'https://certisign.com.br/certificados'
    }
  }

  const handleSubmitToCart = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (offer) {
      setLoading(true);
      setData((prevData) => {
        const updatedData = {
          ...prevData,
          selectedOffer: {
            sku: offer.sku,
            saleType: offer.saleType
          },
          client: {
            cnpj
          }
        };

        postRequest('/api/v1/select-offer', updatedData)
          .then((data) => {
            window.location.href = data.cartUrl
            setLoading(false);
          })
          .catch((error) => {
            setError(error)
            setLoading(false);
          });

        return updatedData;
      });
    }
  }

  const handleCnpjChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCnpj(e.target.value);
  };

  return (
    <Container>
      {error ? (
        <ContentWrapper>
          <TextTop>Código do erro: {error.code}</TextTop>
          <Paragraph>{error.correlationId}</Paragraph>
          <TextTitle>{getErrorCodes(error.code)}</TextTitle>
          {getErrorSubTitle(error?.code ?? '') !== '' ? <TextSubtitle>{getErrorSubTitle(error?.code ?? '')}</TextSubtitle> : null}
          <TextSugestions>{getErrorSugestions(error?.code ?? '')}</TextSugestions>
          <ListErrors dangerouslySetInnerHTML={{__html: getErrorMessage(error?.code ?? '')}}/>
          <ButtonWrapper>
            <ButtonBack onClick={handleCloseModal}><Image src={arrowLeft} alt='Icone voltar' /> Voltar</ButtonBack>
            <ButtonPurchase onClick={handleGoToVitrine}>{error.code === '8001' ? 'Tentar novamente ': 'Ir para vitrine'}</ButtonPurchase>
          </ButtonWrapper>
        </ContentWrapper>
      ) : (
        <ContentWrapper>
          <TextTop>Portabilidade (Compra fácil)</TextTop>
          <TextTitle>Faça a portabilidade do seu certificado agora</TextTitle>
          <TextSubtitle>Digite seu CNPJ e clique no botão "Fazer portabilidade"</TextSubtitle>
          <Form>
            <input
              type="text"
              placeholder="CNPJ"
              name="CNPJ"
              id="field_cnpj"
              maxLength={18}
              value={formattedCnpj || cnpj}
              onChange={handleCnpjChange}
            />
            <ButtonWrapper>
              <ButtonBack onClick={handleCloseModal}><Image src={arrowLeft} alt='Icone voltar' /> Voltar</ButtonBack>
              <ButtonPurchase onClick={handleSubmitToCart}>Fazer portabilidade</ButtonPurchase>
            </ButtonWrapper>
          </Form>
        </ContentWrapper>
      )}
    </Container>
  )
}

export default Modal;